<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_user_temporary"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="true"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
        :query="params"
        @on-add="showFormModalDialog"
        @on-batch-del="onBatchDeleteDone"
      />
    </div>
    <UserResetPasswordDialog
      :id="entityId"
      :visible="modalResetPwd"
      :width="350"
      @on-close="onModalClose"
    />
    <UserTemporaryParkings
      :id="entityId"
      :visible="modalForm"
      :user-name="userName"
      @on-close="onModalClose"
    />
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import UserResetPasswordDialog from './dialog/user-resetpwd'
import UserTemporaryParkings from './dialog/user-parkings'
import request from '@/utils/request'
import { getConfigItem } from '@/apis'
import { getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'
export default {
  name: 'TemporaryUser',
  components: {
    TableWrapper,
    UserResetPasswordDialog,
    UserTemporaryParkings
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/member',
      modalForm: false,
      modalResetPwd: false,
      entityId: 0,
      userName: '',
      modalDelConfirm: false,
      entityName: '',
      modCount: 0,
      garages: this.loadGarages(),
      selection: [],
      timeout: 30000
    }
  },
  computed: {
    addPermited() { return isAdmin() || hasPermission('PEM_MEMBER_DATA_ADD') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_DATA_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_TEMP_MEMBER_DATA_UPDATE') },
    viewTemporaryParkingPermitted() { return isAdmin() || hasPermission('PEM_TEMP_PARKING_DATA_VIEW') },
    params() { return { isTemporary: true } },
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '注册日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择注册日期...', type: 'dateranger' },
          // { label: '账号', placeholder: '请输入会员账号...', name: 'name', width: 'auto', type: 'input' },
          { label: '姓名', placeholder: '请输入会员姓名...', name: 'realName', width: 'auto', type: 'input' },
          { label: '电话号码', placeholder: '请输入会员电话号码...', name: 'mobile', width: 'auto', type: 'input' },
          { label: '临停车库', placeholder: '请选择临停车库...', name: 'parkingId', width: '200px', type: 'select', options: this.garages }
        ]
      }
    },
    columns() {
      const _this = this
      return [
        { type: 'selection', width: 40, align: 'center', key: '_selection', disabled: true },
        { title: '临停车库', align: 'left', key: 'parkings', resizable: true, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.parkings || '---')
          }
        },
        { title: '账号', align: 'center', key: 'name', resizable: true, sortable: true, width: 140, ellipsis: true, tooltip: true },
        { title: '姓名', align: 'center', key: 'realName', resizable: true, sortable: true, width: 140, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.realName || '---')
          }
        },
        // { title: '性别', align: 'center', key: 'gender', sortable: true, width: 80,
        //   render: (h, params) => {
        //     return h('span', { }, params.row.gender === 1 ? '男' : (params.row.gender === 2 ? '女' : '未知'))
        //   }
        // },
        { title: '电话号码', align: 'center', key: 'mobile', resizable: true, sortable: true, width: 140, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.mobile || '---')
          }
        },
        { title: '临停押金', align: 'center', sortable: true, key: 'temporaryDepositPaid', ellipsis: true, tooltip: true, width: 150,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.temporaryDepositPaid === 2 ? 'red' : (params.row.temporaryDepositPaid === 1 ? 'green' : 'red') }
            }, params.row.temporaryDepositPaid === 2 ? '已退费' : (params.row.temporaryDepositPaid === 1 ? '已缴纳' : '未缴纳'))
          }
        },
        { title: '注册时间', align: 'center', sortable: true, key: 'registrationTime', width: 160, ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 250, disabled: true, key: '_actions',
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showResetPwdModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-lock': true, 'cell-icon-link': true }}),
                h('span', {}, '重置密码')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.viewTemporaryParkingPermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.viewTemporaryParkingPermitted) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-warehouse': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.viewTemporaryParkingPermitted ? '临停车库' : '您没有权限查看临停车库' }}, '临停信息')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.deletePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.deletePermitted) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.deletePermitted ? '删除用户' : '您没有权限删除用户' }}, '删除')
              ])
            ])
          }
        }]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showResetPwdModalDialog: function(id, name) {
      this.entityId = id ? parseInt(id) : 0
      this.modalResetPwd = true
    },
    async getMemberSyncTimeout() {
      const res = await getConfigItem(this.$config.apiContextPath + '/config', 'NS_SYSTEM', 'SYNC_MEMBER_TIMEOUT')
      if (res.data && res.data.content.length > 0) {
        try {
          const configItem = res.data.content[0]
          this.timeout = parseInt(configItem.value)
        } catch (err) {
          console.log('Invalid timeout')
        }
      }
    },
    showBindedParkings(id, name) {
      this.entityId = id ? parseInt(id) : 0
      this.modalBindingParking = true
      this.userName = name
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    async showSyncModalDialog(id, realName, name) {
      const _this = this
      this.getMemberSyncTimeout()
      this.$Modal.confirm({
        title: '确认同步用户`' + realName + '`数据么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [
            h('li', {}, '电话: ' + name),
            h('li', {}, '姓名: ' + realName)
          ])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/member',
            data: [id],
            method: 'POST'
          }).then(res => {
            this.$Notice.success({
              title: '数据同步成功',
              desc: '用户 `' + name + '` 数据同步成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据同步失败',
              desc: '用户 `' + name + '` 数据同步失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除用户信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '用户 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '用户 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.entityName = ''
      this.modalForm = false
      this.modalDelConfirm = false
      this.modalResetPwd = false
      this.userName = ''
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    onBatchDeleteDone: function(selections) {
      this.modCount = this.modCount + 1
    }
  }
}
</script>

<style lang="less">
  .avatar {
    img {
      width: 24px;
      height: 24px;
      cursor: zoom-in;
      border: 1px solid #c2bfbf;
    }
  }
</style>
